/**
 * Get plain text from a React element that dangerously sets inner html. E.g. use this to convert a user's rich text
 * label for a field into text to use in a validation message
 */
export default function plainTextFromDangerouslySetInnerHtml(element) {
  if (typeof element === 'string') {
    return element;
  }
  const html = element.props.dangerouslySetInnerHTML.__html;
  const domNode = global.document.createElement('div');
  domNode.innerHTML = html;
  return domNode.innerText;
}
